/** @module ProductSpec/CopyMaterialBomController */
define([
	"dojo/_base/declare",
	"csi/action/CopyController",
	"csi/xml"
], function(declare,CopyController,xml) {

	return declare(CopyController, {
		/**
		 * Add MaterialBOMSubtype and BOMProductColors to the server operation and consume the values
		 * so they don't also get processed as ChangeAttributes by the framework
		 */
		toWriterRequest: function() {
			var fd = this.getFormData();
			var call = this.inherited(arguments);
			call.addParameter("MaterialBOMSubtype", xml.ATTR_REF, fd.getFieldValue("Subtype", true));
			call.addParameter("BOMProductColors", xml.ATTR_REFLIST, fd.getFieldValue("BOMProductColors", true));
			return call;
		}
	});
});